import React from 'react';
import SubServices from '../common/sub-services';
const AngularServies = () => {
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                        <p
                            className="text-primary mb-0 fs-lg fw-700"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            We Provide
                        </p>
                        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            AngularJS Development Services
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 lg:w-10/12 xl:w-8/12 mx-auto">
                    <SubServices
                        path={'/img/technology/ic-webapp.svg'}
                        height={64}
                        width={64}
                        alt="consult"
                        title="consult"
                        serviceName="AngularJS Web Development"
                        serviceDescription="We create beautiful, super-functional, and engaging websites and web applications with our AngularJS web development services."
                    />
                    <SubServices
                        path={'/img/technology/ic-spas.svg'}
                        height={64}
                        width={64}
                        alt="development"
                        title="development"
                        serviceName="AngularJS for SPA"
                        serviceDescription="Hire our expert AngularJS developers to build appealing, super-fast, and UX-rich single-page applications (SPAs) for which AngularJS is popular."
                    />
                    <SubServices
                        path={'/img/technology/ic-ecommerce-development.svg'}
                        height={64}
                        width={64}
                        alt="spas"
                        title="spas"
                        serviceName="AngularJS for eCommerce"
                        serviceDescription="Deliver exceptional user interface and user experience (UI/UX) to your e-commerce stores to ensure faster conversions with the robust & scalable AngularJS apps."
                    />
                    <SubServices
                        path={'/img/technology/ic-mobile-app.svg'}
                        height={64}
                        width={64}
                        alt="portaldevelopment"
                        title="portaldevelopment"
                        serviceName="AngularJS Mobile App Development"
                        serviceDescription="Get powerful front-end developed for your business or enterprise mobile apps with our unmatched AngularJS app development services."
                    />
                </div>
            </div>
        </div>
    );
};

export default AngularServies;
